import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import './Popup.css';
import { BsBroadcast, BsCalendarEvent } from "react-icons/bs";
import { FaPlay } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';


import axios from 'axios';
import { getItemToken } from '../../Utils/localStorageUtils';

const LivestreamPopup = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [liveStreams, setLiveStreams] = useState([]);
    const [loading, setLoading] = useState(false);

    const isLoggedIn = !!localStorage.getItem('access_token');

    const fetchLiveStreams = async () => {
        try {
            setLoading(true);
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/Front-End/Livestream-list`,
                { limit: 50, offset: 0 },
                {
                    headers: getItemToken('access_token') || {
                        'guestverfiykey': "WebVodWebnexs",
                        'Content-Type': 'application/json',
                    }
                }
            );

            if (response.data && response.data.status) {
                setLiveStreams(response.data.data || []);
                return response.data.data || [];
            }
            return [];
        } catch (error) {
            console.error('Error fetching livestreams:', error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const checkAndShowPopup = async () => {
            const isPopupShown = sessionStorage.getItem('livestreamPopupShown');
            if (isPopupShown) return;

            const streams = await fetchLiveStreams();
            if (streams && streams.length > 0) {
                setShow(true);
                sessionStorage.setItem('livestreamPopupShown', 'true');
            }
        };

        checkAndShowPopup();

        // Listen for manual trigger from header
        const handleManualShow = async () => {
            const streams = await fetchLiveStreams();
            if (streams && streams.length > 0) {
                setShow(true);
            }
        };

        window.addEventListener('toggleLivestreamPopup', handleManualShow);
        return () => window.removeEventListener('toggleLivestreamPopup', handleManualShow);
    }, []);

    const handleClose = () => setShow(false);

    if (!liveStreams || liveStreams.length === 0) return null;


    const MiniStreamCard = ({ stream, onClose }) => {
        const isLive = stream.publish_type === 'publish_now';
        const startTime = stream.publish_time ? dayjs(stream.publish_time).format('MMM DD, h:mm A') : '';

        // Check if a publish_later stream has reached its scheduled time
        const hasReachedScheduledTime = stream.publish_type === 'publish_later'
            && stream.publish_time
            && new Date() >= new Date(stream.publish_time);

        // Determine if stream should show "Watch Live" button
        const showWatchLive = isLive || hasReachedScheduledTime;

        // Determine the correct link path
        const watchLiveLink = `/player/live/${stream.slug}`;
        const detailLink = `/live/${stream.slug}`;

        // Handle click: if access is "registered" and user is not logged in, redirect to login
        const handleWatchClick = (e) => {
            if (stream.access === 'registered' && !isLoggedIn) {
                e.preventDefault();
                onClose();
                navigate('/login');
                return;
            }
            onClose();
        };

        return (
            <div className={`mini-stream-card-new ${showWatchLive ? 'is-live' : 'is-upcoming'}`}>
                <div className="mini-thumb-new">
                    <img
                        src={stream.player_image_URL || stream.Thumbnail || stream.image}
                        alt={stream.title}
                        loading="lazy"
                    />

                    {showWatchLive ? (
                        <span className="badge-live">
                            <BsBroadcast className="live-icon-blink" />
                            LIVE
                        </span>
                    ) : (
                        <span className="badge-upcoming">
                            <BsCalendarEvent className="upcoming-icon" />
                            UPCOMING
                        </span>
                    )}

                    {showWatchLive && (
                        <Link
                            to={watchLiveLink}
                            className="play-overlay"
                            onClick={handleWatchClick}
                        >
                            <FaPlay size={18} />
                        </Link>
                    )}
                </div>

                <div className="mini-info-new">
                    <div className="title-section d-flex align-items-center justify-content-between">
                        <h5 className='stream-title'>{stream.title || stream.name}</h5>
                        {!showWatchLive && startTime && (
                            <span className="stream-time">{startTime}</span>
                        )}
                    </div>

                    {stream.description && (
                        <p className='stream-desc'>{stream.description}</p>
                    )}

                    <div className="action-section">
                        <Link
                            to={detailLink}
                            className={`btn-stream theme-button-bg-color theme-button-text-color ${showWatchLive ? 'btn-live' : 'btn-upcoming'}`}
                            onClick={handleWatchClick}
                        >
                            {showWatchLive ? 'Watch Live' : 'View Details'}
                        </Link>
                    </div>
                </div>
            </div>
        );
    };


    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="ott-modern-modal"
            size="xl"
        >
            <Modal.Body className="p-0 theme-bg-color-secondary">
                <div className="modal-header-custom">
                    <h4 className="modal-title-custom theme-text-color">Livestreams</h4>
                    <button className="btn-close-custom theme-button-bg-color theme-button-text-color" onClick={handleClose}>
                        <IoClose size={24} />
                    </button>
                </div>

                <div className="stream-list-container">
                    {liveStreams.map((stream, index) => (
                        <MiniStreamCard key={stream.id || index} stream={stream} onClose={handleClose} />
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default LivestreamPopup;
